import React from "react";
import useUserBrands from "../../../../common/useUserBrands";
import BrandsNavbarSettingsDropdown from "./BrandsNavbarSettingsDropdown";
import {LazyBrandsNavbarSettingsDropdownProps} from "./types";

/**
 * Brand switcher that only fetches the user's brands once the dropdown is opened.
 */
export default function LazyBrandsNavbarSettingsDropdown(props: LazyBrandsNavbarSettingsDropdownProps) {
  const {brands, status, load} = useUserBrands();

  return <BrandsNavbarSettingsDropdown {...props}
                                       companies={status === "success" ? brands : null}
                                       companiesStatus={status}
                                       onRequestCompanies={load}/>;
}
